// client/src/context/AuthContext.js
//Este archivo manejará todo el flujo de sesión (inicio, cierre, persistencia del usuario y rol).
import { createContext, useContext, useEffect, useState } from "react";
import { login } from "../api/usuarios.js";
import { loginSuperAdmin } from "../api/superAdmin.js";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Cargar datos del usuario desde el localStorage si existe sesión activa
    const storedUser = localStorage.getItem("usuario");
    if (storedUser && token) {
      setUsuario(JSON.parse(storedUser));
    }
    setLoading(false);
  }, [token]);

  // Login - Intenta primero como Usuario, luego como SuperAdmin
  const iniciarSesion = async (credenciales) => {
    try {
      // Intentar login como Usuario normal
      const { token, usuario } = await login(credenciales);
      setToken(token);
      setUsuario(usuario);
      localStorage.setItem("token", token);
      localStorage.setItem("usuario", JSON.stringify(usuario));
      return usuario;
    } catch (err) {
      // Si falla, intentar como SuperAdmin
      try {
        // Adaptar credenciales para SuperAdmin (usa "contraseña" con ñ)
        const credencialesSuperAdmin = {
          correo: credenciales.correo,
          contraseña: credenciales.contrasenia || credenciales.contraseña
        };
        
        const { token, superAdmin } = await loginSuperAdmin(credencialesSuperAdmin);
        // Agregar una propiedad para identificar que es SuperAdmin
        const usuarioSuperAdmin = { ...superAdmin, isSuperAdmin: true };
        setToken(token);
        setUsuario(usuarioSuperAdmin);
        localStorage.setItem("token", token);
        localStorage.setItem("usuario", JSON.stringify(usuarioSuperAdmin));
        return usuarioSuperAdmin;
      } catch (superAdminErr) {
        throw err.response?.data?.message || "Error al iniciar sesión";
      }
    }
  };

  // Logout
  const cerrarSesion = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    setToken(null);
    setUsuario(null);
  };

  return (
    <AuthContext.Provider
      value={{
        usuario,
        token,
        loading,
        iniciarSesion,
        cerrarSesion,
        isAuthenticated: !!usuario,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook personalizado
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth debe usarse dentro de un AuthProvider");
  return context;
};
